/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * RGBARRY-CUSTOMIZATION (storefront provenance): the value stamped as `storefront_source` onto
 * every dataLayer EVENT push, so the customer's GTM container can identify and filter events
 * originating from Storefront Next (vs. the legacy SFRA storefront, which never carried this key).
 *
 * Single source of truth shared by the two push sites so the value can never drift:
 * - the central `ga4-datalayer` adapter, which stamps it on every mapped event in `push`, and
 * - the standalone `page_error` push from the root ErrorBoundary (src/analytics/page-error-tracker.tsx),
 *   which renders outside the adapter pipeline and so tags the event inline.
 */
export const STOREFRONT_SOURCE = 'sfnext' as const;
